export const PAGE_LIST_INFO = {
  default: {
    websiteField: 'Achieve',
  },
  achieve: {
    websiteField: 'Achieve',
  },
  'website-wfs': {
    websiteField: 'Weekly Financial Solutions',
  },
  'website-tenant-2': {
    websiteField: 'FDR',
  },
  'website-fdr': {
    websiteField: 'Freedom Debt Relief',
  },
  'website-ffn': {
    websiteField: 'Freedom Financial Network',
  },
  'website-bills': {
    websiteField: 'Bills',
  },
}
